module.exports = __webpack_public_path__ + "img/CloudUploadOutlined.160db7c1.svg";